import React from "react";
import Container from "@mui/material/Container";
import Layout from "../../layouts";
import GiftCardWorking from "../DASHBOARD/GiftCardWorking";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import useMediaQuery from "@mui/material/useMediaQuery";
import HeaderBanner from "../../assets/others/privacy-policy.png";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import {
    Box,
    List,
    ListItem,
    ListItemText,
} from "@mui/material";
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import { NavLink } from "react-router-dom";

const PrivacyPolicy = (props) => {
    const { isMobile = false } = props;
    const Mobile = useMediaQuery("(max-width:480px)");
    const backgroundColor = Mobile ? "#fff" : "white.main";
    const location = useLocation();
    const canonicalUrl = `https://www.99gift.ae${location.pathname}`;
    const giftCardContiner = {
        boxShadow: { xs: 0, sm: 1, md: 2 },
        borderRadius: { xs: 0, sm: 1, md: 3 },
        p: { xs: 0, sm: 2, md: 3 },
        my: { xs: 2, sm: 3, md: 3 },
        backgroundColor: backgroundColor,
    };

    const giftCardStyle = {
        my: { xs: 0, md: 0 },
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Privacy Policy - 99Gift</title>
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content="Privacy Policy - 99Gift" />
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>

            {!isMobile &&
                (
                    <Container maxWidth="xl" >
                        <PageBreadcrumb
                            home="Home"
                            currentProduct="Privacy Policy"
                        />
                    </Container>
                )
            }

            <Container maxWidth="false" disableGutters>
                <Box sx={{
                    objectFit: "cover",
                    minHeight: {
                        xs: "130px",
                        sm: "130px",
                        md: "130px",
                        lg: "216px"
                    },
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <img src={HeaderBanner} alt="Header Banner" style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                </Box>
            </Container>

            <Container
                maxWidth="false"
                disableGutters={true}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#F1F5F6",
                    "@media (max-width:480px)": {
                        backgroundColor: "white.main",
                    },
                }}
            >
                <Grid
                    container
                    alignItems="center"
                    maxWidth="lg"
                    sx={{
                        px: { xs: 2, md: 0 },
                        justifyContent: "center"
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        sx={{
                            mt: { xs: 2, sm: 2, md: 2 },
                            mb: { xs: 1, sm: 1, md: 1 },
                            background: { xs: "#c9f2ff", sm: "transparent" },
                            borderRadius: { xs: 2, sm: 0 },
                            boxShadow: { xs: 0, sm: 0 },
                            p: { xs: 1, sm: 0 },
                            justifyContent: "center",
                            display: "flex",
                        }}
                    >
                        <PrivacyPolicyTitle />
                    </Grid>
                    <Grid item xs={12}>
                        <PrivacyPolicyUse giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyDisclosure giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyInformationSecurity
                            giftCardContiner={giftCardContiner}
                        />
                        <PrivacyPolicyAccessAndCorrection
                            giftCardContiner={giftCardContiner}
                        />
                        <PrivacyPolicyAnonymous giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyGlossary giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyUserAccountDeletion
                            giftCardContiner={giftCardContiner}
                        />
                        <PrivacyPolicyUserDataSecurity giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyCookiesPolicy giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyYourRights giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyChildren giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyThirdParty giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyUpdates giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyContactUs giftCardContiner={giftCardContiner} />
                        <PrivacyPolicyOfficeDetails giftCardContiner={giftCardContiner} />

                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
};

export default PrivacyPolicy;

function PrivacyPolicyTitle() {
    return (
        <React.Fragment>
            <Typography
                variant="body2"
                color="primary.main"
                sx={{
                    fontSize: { xs: "18px", md: "18px" },
                    textTransform: "capitalize",
                    display: "inline-block",
                }}
            >
                Company
            </Typography>
            <Typography
                variant="body2"
                color="secondary.main"
                sx={{
                    fontSize: { xs: "18px", md: "18px" },
                    textTransform: "capitalize",
                    display: "inline-block",
                }}
            >
                Privacy Policy
            </Typography>
        </React.Fragment>
    );
}

function PrivacyPolicyInnerTitle({ param1, param2 }) {
    return (
        <React.Fragment>
            {param1 && (
                <Typography
                    variant="h3"
                    color="priimary.main"
                    sx={{
                        display: "inline-block",
                        fontSize: { xs: "20px", md: "18px" },
                    }}
                >
                    {param1}
                </Typography>
            )}
            {param2 && (
                <Typography
                    variant="h3"
                    color="secondary.main"
                    sx={{
                        display: "inline-block",
                        ml: { xs: "2px", md: "3px" },
                        fontSize: { xs: "20px", md: "18px" },
                    }}
                >
                    {param2}
                </Typography>
            )}
        </React.Fragment>
    );
}

function PrivacyPolicyUse({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Various options: You get to choose from over 160 options of Gift Cards. So, every shopper get almost everything according to their needs.",
        },
        {
            content:
                "Major discounts: Various types of gift cards come with discounts which reduces the load from your budget.",
        },
        {
            content:
                "Simple buying and redemption of Gift Cards: You can buy Gift cards easily in a small amount of time from our portal and also from 99gift application.",
        },
        {
            content:
                "Great substitution for Gifting: With Gift cards, you can give your loved ones something which is totally in use.Find a range of Gifting options for all occasions like Diwali, birthdays, New Year, anniversaries, etc. You can also send them instantly on Valentine's Day, Father’s Day, Mother’s Day, and other such special days.",
        },
        {
            content:
                "Great for the environment: We don’t use or issue plastic Cards that are harmful to the environment. Everything is online; which you contribute to the planet by buying a voucher from here.",
        },
        {
            content:
                "Environment friendly options: We don’t issue physical/plastic gift cards neither we encourage the use of the plastic, since it is harmful for the environment. Gift cards are online and you can contribute in Green Revolution by purchasing from here.",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param2="Use" />
                </Grid>

                <Grid item xs={12}>
                    <List>
                        {/* point 1 */}
                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                // primary="1."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "At 99gift, we are committed to protecting your privacy and safeguarding your personal data. This Privacy Policy explains how we collect, use, store, share, and protect your information when you visit or use our website and services. We operate with transparency and in accordance with applicable data protection principles and regulations in the United Arab Emirates (UAE)."
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>

                        {/* point 2 */}
                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                // primary="2."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "By accessing or using 99gift, you agree to the practices described in this Privacy Policy"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>

                        {/* point 3 */}
                        {/* <ListItem dense sx={{ pl: "0" }}>
              <ListItemText
                primary="3."
                primaryTypographyProps={{
                  fontSize: { xs: "14.5px", md: "16px" },
                  color: "dark.main",
                  fontWeight: { xs: 400, md: 300 },
                  display: "inline",

                  mr: { xs: "3px", md: "3px" },
                }}
                secondary={
                  "99gift may use Personal Information if ordered by the Government of India and/or any other law enforcing agency for reasons related to law enforcement or internal investigations into unlawful activities."
                }
                secondaryTypographyProps={{
                  fontSize: { xs: "13.5px", md: "16px" },
                  color: "dark.main",
                  fontWeight: { xs: 400, md: 300 },
                  display: "inline",
                }}
              />
            </ListItem> */}

                        {/* point 4 */}
                        {/* <ListItem dense sx={{ pl: "0" }}>
              <ListItemText
                primary="4."
                primaryTypographyProps={{
                  fontSize: { xs: "14.5px", md: "16px" },
                  color: "dark.main",
                  fontWeight: { xs: 400, md: 300 },
                  display: "inline",

                  mr: { xs: "3px", md: "3px" },
                }}
                secondary={
                  "99gift will not use Data where there is a doubt that the information is accurate, complete and up to date."
                }
                secondaryTypographyProps={{
                  fontSize: { xs: "13.5px", md: "16px" },
                  color: "dark.main",
                  fontWeight: { xs: 400, md: 300 },
                  display: "inline",
                }}
              />
            </ListItem> */}
                    </List>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyDisclosure({ giftCardContiner }) {
    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param2="Information We Collect" />
                </Grid>
                <ListItem dense sx={{ pl: "0" }}>
                    <ListItemText
                        // primary="2."
                        primaryTypographyProps={{
                            fontSize: { xs: "14.5px", md: "16px" },
                            color: "dark.main",
                            fontWeight: { xs: 400, md: 300 },
                            display: "inline",

                            mr: { xs: "3px", md: "3px" },
                        }}
                        secondary={
                            "To provide our digital gift card services efficiently and securely, we may collect the following types of information:"
                        }
                        secondaryTypographyProps={{
                            fontSize: { xs: "13.5px", md: "16px" },
                            color: "dark.main",
                            fontWeight: { xs: 400, md: 300 },
                            display: "inline",
                        }}
                    />
                </ListItem>

                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param2="Personal Information" />
                    <List>
                        {/* point 1 */}
                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText

                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "When you place an order, create an account, or contact us, we may collect:"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>
                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                primary="1."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "	Full name"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>
                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                primary="2."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "Email address"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>

                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                primary="3."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "Mobile number"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>

                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                primary="4."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "Billing details"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>

                        <ListItem dense sx={{ pl: "0" }}>
                            <ListItemText
                                primary="5."
                                primaryTypographyProps={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",

                                    mr: { xs: "3px", md: "3px" },
                                }}
                                secondary={
                                    "Delivery email address (for gift card delivery)"
                                }
                                secondaryTypographyProps={{
                                    fontSize: { xs: "13.5px", md: "16px" },
                                    color: "dark.main",
                                    fontWeight: { xs: 400, md: 300 },
                                    display: "inline",
                                }}
                            />
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyInformationSecurity({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Gift card brand and value",
        },
        {
            content: `Transaction date and reference number`,
        },
        {
            content:
                "Payment confirmation status.",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param1="Transaction " param2="Information" />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We collect details related to your purchases, including:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We do not store your complete card or banking details. All payments are processed through secure, authorized payment gateways
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyAccessAndCorrection({ giftCardContiner }) {
    const orders = [
        {
            content:
                "IP address",
        },
        {
            content: `Browser type and device information`,
        },
        {
            content:
                "Pages visited and time spent",
        },
        {
            content:
                "Cookies and similar tracking technologies",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param1="Technical & " param2="Usage Information" />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        When you browse our website, we may automatically collect:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        This data helps us improve website performance and user experience.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyAnonymous({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Processing and delivering digital gift cards",
        },
        {
            content: `Verifying payments and preventing fraud`,
        },
        {
            content:
                "Communicating order confirmations and service updates",
        },
        {
            content: `Responding to customer inquiries and support requests`,
        },
        {
            content: `Improving our website, services, and security`,
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param1="How We Use Your " param2="Information" />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We use your information only for legitimate business purposes, including:
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        Your personal data is never used for unlawful or misleading purposes.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyGlossary({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Lawful and transparent data collection",
        },
        {
            content:
                "Purpose limitation (data used only for stated purposes)",
        },
        {
            content:
                "Data minimization and accuracy",
        },
        {
            content:
                "Security and confidentiality",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle param1="Legal Basis & Compliance in " param2="the UAE" />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        99gift follows data protection principles recognized in the UAE, including:
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We take reasonable technical and organizational measures to ensure that personal data is handled responsibly and protected against unauthorized access, alteration, or misuse.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyUserAccountDeletion({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Trusted payment gateway providers",
        },
        {
            content:
                "Technology and hosting service providers",
        },
        {
            content:
                "Legal or regulatory authorities if required by UAE law",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Sharing of "
                        param2="Information "
                    />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We do not sell, rent, or trade your personal data.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We may share limited information only with:
                    </Typography>
                </Grid>


                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        All third parties are obligated to protect your data and use it only for agreed purposes.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyUserDataSecurity({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Secure servers",
        },
        {
            content:
                "Encrypted connections (SSL)",
        },
        {
            content:
                "Restricted internal access",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Data Storage "
                        param2="Security "
                    />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        Your information is stored securely using industry-standard security measures such as:
                    </Typography>
                </Grid>



                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        We retain personal data only for as long as necessary to fulfill business, legal, or regulatory requirements in the UAE.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyCookiesPolicy({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Improve website functionality",
        },
        {
            content:
                "Analyse traffic and user behaviour",
        },
        {
            content:
                "Enhance personalization and performance",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Cookies  "
                        param2="Policy "
                    />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        99gift uses cookies to:
                    </Typography>
                </Grid>



                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        You may control or disable cookies through your browser settings. Please note that disabling cookies may affect certain website features.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyYourRights({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Request access to your personal data",
        },
        {
            content:
                "Request correction of inaccurate information",
        },
        {
            content:
                "Request deletion of your data (subject to legal requirements)",
        },
        {
            content:
                "Withdraw consent for marketing communications",
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Your"
                        param2="Rights "
                    />
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        As a user in the UAE, you have the right to:
                    </Typography>
                </Grid>



                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText
                                        primary={`${index + 1}.`}
                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} sx={{ mb: 0, mt: { xs: 1, md: 1 } }}>
                    <Typography
                        variant="body2"
                        color="dark.main"
                        sx={{ fontSize: { xs: "13.5px", md: "16px" } }}
                    >
                        To exercise your rights, you may contact us using the details provided on our website
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyChildren({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Our services are intended for users aged 18 years and above. We do not knowingly collect personal information from minors. If such data is identified, it will be promptly removed",
        },


    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Children’s"
                        param2=" Privacy "
                    />
                </Grid>




                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText

                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>

            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyThirdParty({ giftCardContiner }) {
    const orders = [
        {
            content:
                "Our website may contain links to third-party websites or brand partners. We are not responsible for their privacy practices and encourage users to review their respective privacy policies.",
        },


    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Third-Party"
                        param2=" Links "
                    />
                </Grid>




                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText

                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>

            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyUpdates({ giftCardContiner }) {
    const orders = [
        {
            content:
                "We may update this Privacy Policy from time to time to reflect changes in legal requirements, business operations, or technology. Any updates will be posted on this page with a revised effective date.",
        },


    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Updates to"
                        param2="This Policy "
                    />
                </Grid>




                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText

                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>

            </Grid>
        </React.Fragment>
    );
}
function PrivacyPolicyContactUs({ giftCardContiner }) {
    const orders = [
        {
            content:
                "If you have any questions or concerns regarding this Privacy Policy or how your data is handled, please contact us through the official support channels listed on 99gift.",
        },


    ];

    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="Contact"
                        param2="Us "
                    />
                </Grid>




                <Grid item xs={12}>
                    <List>
                        {orders.map((order, index) => (
                            <ListItem key={order.id} dense sx={{ pl: "0" }}>
                                {order?.icon && (
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        {order?.icon}
                                    </ListItemIcon>
                                )}
                                {order?.content && (
                                    <ListItemText

                                        primaryTypographyProps={{
                                            fontSize: { xs: "14.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",

                                            mr: { xs: "3px", md: "3px" },
                                        }}
                                        secondary={order?.content}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13.5px", md: "16px" },
                                            color: "dark.main",
                                            fontWeight: { xs: 400, md: 300 },
                                            display: "inline",
                                        }}
                                    />
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>

            </Grid>
        </React.Fragment>
    );
}

function PrivacyPolicyOfficeDetails({ giftCardContiner }) {
    return (
        <React.Fragment>
            <Grid
                container
                sx={{
                    ...giftCardContiner,
                }}
            >
                <Grid item xs={12}>
                    <PrivacyPolicyInnerTitle
                        param1="99gift"
                        param2="Information"
                    />
                </Grid>

                <Grid item xs={12}>
                    <List>
                        {/* Telephone */}
                        {/* <ListItem dense sx={{ pl: "0" }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "primary.main",
                                    fontWeight: { xs: 500, md: 500 },
                                    display: "block",
                                    width: 100,

                                    marginRight: { xs: "3px", md: "3px" },
                                }}
                            >
                                Telephone:
                            </Typography>
                            <NavLink
                                to="tel:+9718742998998"
                                style={{
                                    fontSize: "16px",
                                    color: "#00B8EE",
                                    fontWeight: { xs: 500, md: 600 },
                                    display: "inline-block ",
                                }}
                            >
                                +971 8742998998
                            </NavLink>
                        </ListItem> */}

                        {/* Website */}
                        <ListItem dense sx={{ pl: "0" }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "primary.main",
                                    fontWeight: { xs: 500, md: 500 },
                                    display: "block",
                                    width: 100,

                                    marginRight: { xs: "3px", md: "3px" },
                                }}
                            >
                                Website:
                            </Typography>
                            <NavLink
                                to="www.99gift.ae"
                                target="_blank"
                                style={{
                                    fontSize: "16px",
                                    color: "#00B8EE",
                                    fontWeight: { xs: 500, md: 600 },
                                    display: "inline-block ",
                                }}
                            >
                                www.99gift.ae
                            </NavLink>
                        </ListItem>

                        {/* Email */}
                        <ListItem dense sx={{ pl: "0" }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "14.5px", md: "16px" },
                                    color: "primary.main",
                                    fontWeight: { xs: 500, md: 500 },
                                    display: "block",
                                    width: 100,

                                    marginRight: { xs: "3px", md: "3px" },
                                }}
                            >
                                Email:
                            </Typography>
                            <NavLink
                                to="mailto:info@99gift.in"
                                style={{
                                    fontSize: "16px",
                                    color: "#00B8EE",
                                    fontWeight: { xs: 500, md: 600 },
                                    display: "inline-block ",
                                }}
                            >
                                info@99gift.ae
                            </NavLink>
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
